import { filter, map } from 'lodash';
import { ConsumerGroupOrderFieldsFragment, User } from 'src/gqlReactTypings.generated.d';
import {
  GroupOrderFoodItemRating,
  GroupOrderFoodItemRatings,
} from 'src/pages/components/GroupOrderModal/GroupOrderFoodItemRating';
import { ShefHeader } from 'src/pages/components/ratings/ConsumerGroupOrderRatingModal/ShefHeader';
import { Header, HeaderSection } from 'src/pages/components/ratings/ConsumerGroupOrderRatingModal/styles';
import { ButtonSizes, PrimaryButton } from 'src/shared/design-system/Buttons';
import { DishFirstModal, DishFirstModalBody } from '../../dish-first/DishFirstModal';

interface ConsumerGroupOrderMessageModalProps {
  groupOrder: ConsumerGroupOrderFieldsFragment;
  onClose: () => void;
  openChatWidget: (recipient: Pick<User, 'flakeId' | 'publicName'>) => void;
}

export const ConsumerGroupOrderMessageModal = ({
  groupOrder,
  onClose,
  openChatWidget,
}: ConsumerGroupOrderMessageModalProps): JSX.Element | null => {
  const ordersWithChatableShefs = filter(groupOrder.orders, (order) => order.shefProfile.allowedToChat);

  if (ordersWithChatableShefs.length === 0) {
    return null;
  }

  const deliveryDateString = new Date(groupOrder.deliveryDate).toLocaleString([], {
    day: 'numeric',
    month: 'short',
  });

  return (
    <DishFirstModal isShowing onClose={onClose}>
      <DishFirstModalBody>
        <HeaderSection>
          <Header>Message shefs from your order on {deliveryDateString}</Header>
        </HeaderSection>
        <GroupOrderFoodItemRatings>
          {map(ordersWithChatableShefs, ({ publicShef, lineItems }) => (
            <>
              <ShefHeader publicShef={publicShef}>
                <PrimaryButton size={ButtonSizes.XS} onClick={() => openChatWidget(publicShef)}>
                  Message
                </PrimaryButton>
              </ShefHeader>

              {lineItems.map(({ id: lineItemId, foodItem }) => (
                <GroupOrderFoodItemRating key={lineItemId} foodItem={foodItem} />
              ))}
            </>
          ))}
        </GroupOrderFoodItemRatings>
      </DishFirstModalBody>
    </DishFirstModal>
  );
};
